import {
  CreateEmissorInstallationItem,
  CreateEmissorInstallationRequestData,
} from 'services/interfaces/installation/installation';
import { onlyDocumentChars } from 'shared/helpers/string';

const OPTIONAL_INSTALLATION_KEYS = [
  'apelido',
  'nome_fantasia',
  'razao_social',
  'inscricao_estadual',
  'inscricao_municipal',
  'endereco',
  'numero',
  'bairro',
  'cod_cidade',
  'cep',
  'telefone',
  'email',
] as const;

export interface LegacyEmissorJson {
  instalacoes?: Array<Record<string, unknown>>;
  produtos?: unknown[];
  produtos_categorias?: unknown[];
  data_inc?: string;
  ambiente?: string;
}

function mapInstallationItem(
  item: Record<string, unknown>,
): CreateEmissorInstallationItem {
  const mapped: CreateEmissorInstallationItem = {
    cnpj: onlyDocumentChars(String(item.cnpj ?? '')),
  };

  for (const key of OPTIONAL_INSTALLATION_KEYS) {
    const value = item[key];
    if (typeof value === 'string') {
      mapped[key] = value;
    }
  }

  return mapped;
}

export function buildEmissorPayload(
  json: LegacyEmissorJson,
  customerId: number,
): CreateEmissorInstallationRequestData {
  const rawInstallations = Array.isArray(json.instalacoes)
    ? json.instalacoes
    : [];

  return {
    customer_id: customerId,
    instalacoes: rawInstallations.map(mapInstallationItem),
    produtos: Array.isArray(json.produtos) ? json.produtos : [],
    produtos_categorias: Array.isArray(json.produtos_categorias)
      ? json.produtos_categorias
      : [],
    data_inc: json.data_inc || new Date().toISOString(),
    ambiente: 'P',
  };
}
